module.exports = __webpack_public_path__ + "static/img/1_8.99d54ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_8.png
// module id = WIUm
// module chunks = 44